import axios from 'axios'

const fetchSelectedEvent = async ({ rootState, commit }, payload) => {
  return await axios.post(`${rootState.baseURL}/events/list`, payload, {})
  .then((res) => {
    commit('updateSelectedEvent', res.data.data[0])
  })
}

export default {
  fetchSelectedEvent,
}
